<template>
  <div class="body">
    <div class="main_container">
      <training-header :appConfig = "appConfig"  ></training-header>

      <!-- page content -->
      <div class="right_col resources_block_page" role="main" style="margin-left: 0;padding:0px 20px;">
        <br />

        <div class="row px-4 pt-4">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_content">
                <div class="process_steps">
                  <ul class="steps">
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Download</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Customize</span>
                      </div>
                    </li>
                    <!-- <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Upload</span>
                      </div>
                    </li> -->
                    <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Complete</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row px-4">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel resourceSessionPage">
              <div class="">
                <b-tabs pills card content-class="mt-3" fill >
                  <template v-for="(sess,sessind) in facilitatorObj.sessions">
                   <b-tab :title="`${sess.session}`" active>
                     <div >
                       <b-tabs pills card content-class="mt-3" fill >
                         <template v-for="cat,catind in sess.category" >
                          <b-tab :title="`${cat.category}`" active>
                            <div class="d-flex">
                              <template v-for="res,resind in cat.resourse">
                            <div
                              class="panel panel-default panel-card"
                              style="background-color: #50abc9; border-color: #50abc9;"
                            >
                              <div
                                class="panel-heading"
                                style="background-color: #50abc9;border-color: #50abc9;"
                              >{{res.header}}</div>
                              <div class="panel-body" style="background: #3c5162;">
                                <div class="panel-img">
                                  <img :src="res.photoBlob" />
                                </div>
                                <div class="dynamicTextDiv" v-html="res.content">
                                </div>

                               <!--  <div class="dynamicTextDiv" >
                                  <a :href="res.downloadLink" style="color: #ffffff" target="_blank">Download</a>
                                </div>-->
                                <!-- <ul>
                                  <li v-for="(con, j) in data.contents" :key="j">{{con.contentBody}}</li>
                                </ul> -->
                              </div>
                                 <div
                                  class="panel-footer"
                                  style="background-color: #50abc9;
                                  border-color: #50abc9;"
                                ><a :href="res.downloadLink" style="color: #ffffff"  target="_blank">Download</a></div>
                             

                            </div>
                          </template>
                            </div>
                          </b-tab>
                        </template>
                       </b-tabs>
                     </div>
                   </b-tab>
                 </template>
                 </b-tabs>
                <!-- <ul class="nav nav-pills nav-justified" id="pills-tab" role="tablist" >
                  <li class="nav-item">
                    <a data-toggle="tab" :href="`#home${sessind}`" class="nav-link active text-center" style="border-radius:10px 0 0 0;">Download resources for {{sess.session}}</a>
                  </li>
                  <li class="nav-item" >
                    <a data-toggle="tab" href="#menu1" class="nav-link text-center" style="border-radius:0px 10px 0 0;">Download resources for web based sessions</a>
                  </li>
                </ul> -->

                <div class="clearfix"></div>
              </div>
              <div class="x_content">
                <!-- <div class="dashboard-widget-content" style="padding-top: 3%;" v>
                  <div class="tab-content">
                    <div id="home" class="tab-pane container active">
                      <div class="row" v-if="planningData">
                        <div class="col-xl-3 col-sm-4" v-for="(data, i) in planningData[0].headers" :key="i">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >{{data.header}}</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li v-for="(con, j) in data.contents" :key="j">{{con.contentBody}}</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                              border-color: #50abc9;"
                            ><a :href="data.downloadLink" style="color: #ffffff">Download</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="menu1" class="tab-pane container fade">
                      <div class="row" v-if="planningData">
                        <div class="col-xl-3 col-sm-4" v-for="(data, i) in planningData[0].headers" :key="i">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >{{data.header}}</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li v-for="(con, j) in data.contents" :key="j">{{con.contentBody}}</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                              border-color: #50abc9;"
                            ><a :href="data.downloadLink" style="color: #ffffff">Download</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div style="text-align: center; margin-bottom: 3%; margin-top: 3%; padding-bottom:5%;">
                  <router-link :to="{ name: 'facilitator-menu', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="margin-right: 5%;">
                    <i
                    class="fa fa-angle-double-left"
                    aria-hidden="true"
                    style="padding-right: 1%;"
                    ></i> Previous
                  </router-link>

                  <router-link :to="{ name: 'facilitator-course', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="color: #3471ce;">
                    Next
                    <i
                      class="fa fa-angle-double-right"
                      aria-hidden="true"
                      style="padding-left: 1%;"
                    ></i>
                  </router-link>
                  <!-- <a href="facilitator_menu.html" class="btn btn-danger btn-md btn3d" role="button">Next</a>
                  <a href="login.html" class="btn btn-cust1 btn-md btn3d" role="button">Skip to Login</a>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <training-footer :appConfig="appConfig"></training-footer>
      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';
export default {
    components: {
        trainingHeader,
        trainingFooter
    },
    data(){
      return {
        planningData: null,
        facilitatorObj:{},
        appConfig:{}
      }
    },
    methods: {
      getPlanningData(){
        this.$root.loading = true;
        ApiServices.RestPostCall('api/avenir/training/getPlanningData',{}).then(res=>{
          console.log(res);
          this.planningData = res.masterAgenda
          this.$root.loading = false;
        })
      }
    },
    mounted(){
      //this.getPlanningData()
      if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
    }
      if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
      }
    }
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff !important;
        border: 0px solid transparent;
        padding:0 !important;
        border-radius: 10px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 0 !important;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 10px 10px 0 0;
    }
    .x_content {
        padding: 0px 25px 6px;
    }
    .panel-img img{
        width: 100px;
        height: 100px;
        margin: 10px auto;
    }
    .dashboard-widget-content{
        height: 350px;
        overflow: hidden;
        overflow-y: scroll;
    }

</style>
